<div class="pdf-page app-aul-002-24" id="aul00224">
  <!-- <app-policy-header></app-policy-header> -->
  <p class="font-large" style="text-align: center">
    <b>COMMERCIAL PROPERTY SUPPLEMENTAL DECLARATIONS</b>
  </p>
  <p class="font-medium">
    <b>
      This Commercial Property Supplemental Declarations is attached to and
      forms part of the Policy number {{ this.policyDetails?.policyNo }}
    </b>
  </p>
  <p class="font-small">
    Coinsurance condition percentage to apply to all Coverage Sections 90% unless
    otherwise described in the Policy.
  </p>
  <br />
  <br />
  <ng-container
    *ngFor="let address of this.policyDetails?.addressInfo; let i = index"
  >
    <table class="font-small" style="width: 100%">
      <tbody>
        <tr>
          <td style="width: 50%">
            <b
              >Covered Premises Address {{ i + 1 }} of
              {{ this.policyDetails?.addressInfo?.length }}</b
            >
          </td>
          <td style="width: 50%"><b>Occupancy</b></td>
        </tr>
        <tr>
          <td style="width: 50%">
            <b
              >{{ address?.streetNum }}, {{ address?.streetName }},
              {{ address?.unitNum ? address?.unitNum + "," : "" }}
              {{ address?.city }}, {{ address?.county }}, {{ address?.state }},
              {{ address?.zipcode }}</b
            >
          </td>
          <td style="width: 50%">
            <b>{{ address?.occupany }}</b>
          </td>
        </tr>
      </tbody>
    </table>
    <table class="font-small" style="width: 100%">
      <tbody *ngFor="let building of address?.buildings; let i = index">
        <tr>
          <td style="width: 50%"><b>Coverage Sections</b></td>
          <td style="width: 50%"><b>Limit of Insurance</b></td>
        </tr>
        <tr>
          <td style="width: 50%">Building {{ i + 1 }}</td>
          <td style="width: 50%">
            $ {{ building?.buildingLimit | currency : "USD" : "" : "1.2-2" }}
          </td>
        </tr>
        <tr>
          <td style="width: 50%">Ordinance or Law</td>
          <td style="width: 50%">
            {{ building?.oandLFlag === 1 ? "Included" : "Excluded" }}
          </td>
        </tr>
        <tr>
          <td style="width: 50%">Business Personal Property</td>
          <td style="width: 50%">
            $
            {{
              building?.businessPropertyLimit | currency : "USD" : "" : "1.2-2"
            }}
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <table class="font-small" style="width: 100%">
      <tbody>
        <tr>
          <td style="width: 50%"><b>Business Income and Extra Expense</b></td>
          <td style="width: 50%">
            $
            {{ address?.businessIncomeLimit | currency : "USD" : "" : "1.2-2" }}
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <table class="font-small" style="width: 100%">
      <tbody
        *ngFor="
          let addnlStructure of address?.additionalStructures;
          let i = index
        "
      >
        <tr>
          <td style="width: 50%"><b>Additional Property Coverage</b></td>
          <td style="width: 50%"></td>
        </tr>
        <tr>
          <td style="width: 50%">
            {{ addnlStructure?.otherStructureOtherDesc }}
          </td>
          <td style="width: 50%">
            $
           
             {{
                (addnlStructure?.otherStructureFactorAmount ?? 0)
                  | currency : "USD" : "" : "1.2-2"
            }}
          </td>
        </tr>
      </tbody>
    </table>
  </ng-container>
  <table class="font-small" style="width: 100%">
    <tbody>
      <tr>
        <td style="width: 50%"><b>Total limit of Insurance</b></td>
        <td style="width: 50%">
          $
          {{
            this.policyDetails?.totalInsuredValue
              | currency : "USD" : "" : "1.2-2"
          }}
          <b>All Covered Premises</b>
        </td>
      </tr>
    </tbody>
  </table>
  <br />
  <table class="font-small" style="width: 100%">
    <tbody>
      <tr>
        <td style="width: 50%"><b>Coverage and Deductibles</b></td>
        <td style="width: 50%"></td>
      </tr>
      <tr>
        <td style="width: 50%">
          Covered Causes of Loss and Basis of Valuation
          <p style="font-style: italic; font-size: 9px">
            *Unless as notified in the Policy Forms and Endorsements
          </p>
        </td>
        <td style="width: 50%">{{ this.policyDetails?.causeOfLossDesc }}</td>
      </tr>
      <tr>
        <td style="width: 50%">All Other Cause of Loss Deductible</td>
        <td style="width: 50%">
          {{ this.policyDetails?.aopDeductibleDescription }}
        </td>
      </tr>
    </tbody>
  </table>
  <table class="font-small" style="width: 100%">
    <tbody>
      <tr>
        <td style="width: 50%">Wind and Hail</td>
        <td style="width: 50%">
          {{
            this.policyDetails?.windDeductibleFlag === 0
              ? "Included"
              : "Excluded"
          }}
        </td>
      </tr>
      <tr>
        <td style="width: 50%">Wind and Hail Deductible</td>
        <td style="width: 50%">
          {{ this.policyDetails?.windDeductibleDescription }}
        </td>
      </tr>
      <tr>
        <td style="width: 50%">Property Enhancement</td>
        <td style="width: 50%">
          {{
            this.policyDetails?.propertyExtCoverageDescription === ""
              ? "No enhancement selected"
              : this.policyDetails?.propertyExtCoverageDescription
          }}
        </td>
      </tr>
      <tr>
        <td style="width: 50%">Water Damage</td>
        <td style="width: 50%">
          {{ this.policyDetails?.waterDamageDescription }}
        </td>
      </tr>
      <tr>
        <td style="width: 50%">Theft Coverage</td>
        <td style="width: 50%">
          {{ this.policyDetails?.vandalismDescription }}
        </td>
      </tr>
    </tbody>
  </table>
</div>
<br />
<div class="pdf-page app-aul-002-24">
  <!-- <app-policy-header></app-policy-header>-->
  <p class="font-large" style="text-align: center">
    <b>COMMERCIAL PROPERTY SUPPLEMENTAL DECLARATIONS</b>
  </p>
  <p class="font-small">
    <b>
      This Commercial Property Supplemental Declarations is attached to and
      forms part of the Policy number {{ this.policyDetails?.policyNo }}</b
    >
  </p>
  <br />
  <p class="font-medium" style="text-align: center">
    <b>Schedule of Mortgageholders And Loss Payees</b>
  </p>
  <br />
  <ng-container
  *ngFor="let address of this.policyDetails?.addressInfo; let i = index"
>
    <div class="font-small">
      <p>
        <b>
          Covered Premises Address {{ i + 1 }} of
          {{ this.policyDetails?.addressInfo?.length }}</b
        >
      </p>
      <p>
        <b>
          {{ address?.streetNum }}, {{ address?.streetName }},
          {{ address?.unitNum ? address?.unitNum + "," : "" }}
          {{ address?.city }}, {{ address?.county }}, {{ address?.state }},
          {{ address?.zipcode }}</b
        >
      </p>
      <ng-container
        *ngFor="let lossPayeeWithBuilding of address?.lossPayeesWithBuilding; let j = index"
      >
        <p>
          Building Number {{ lossPayeeWithBuilding?.buildingNumber }}
        </p>
        <p>{{ lossPayeeWithBuilding?.lossPayee?.lossPayeeclause }}</p>
        <p>{{ lossPayeeWithBuilding?.lossPayee?.lossPayeeName }}</p>
        <p>
          {{ lossPayeeWithBuilding?.lossPayee?.streetNum }},{{
            lossPayeeWithBuilding?.lossPayee?.streetName
          }},
          {{
            lossPayeeWithBuilding?.lossPayee?.unitNum
              ? lossPayeeWithBuilding?.lossPayee?.unitNum + ","
              : ""
          }}
          {{ lossPayeeWithBuilding?.lossPayee?.city }},
          {{ lossPayeeWithBuilding?.lossPayee?.county }},
          {{ lossPayeeWithBuilding?.lossPayee?.state }},
          {{ lossPayeeWithBuilding?.lossPayee?.zipcode }}
        </p>
        <br />
      </ng-container>
    </div>
</ng-container>
</div>
